import { FORM_LOADER, DASHBOARD_CONTAINER } from '../../../types/types';
import { getParameters } from '../../../helpers/helpers';
import { TERMINAL_DEFAULT_TAX } from './form-terminal-tax-types';
import { displayDefaultTaxes } from '../../widgets/tax-cg-terminal-widget';
import { taxListWidget } from '../../widgets/tax-list-widget';
import { searchAvailableItems, searchClear } from '../form-search';
import useAuth from '../../../hooks/auth-hooks';

import { addTerminalTax } from './add-terminal-tax';

import { ITerminal } from '../../../models/terminal.interface';
import { displayIndividualTerminal } from '../../../routes/get-terminal-individual';
import { getTerminalTaxes } from '../../../routes/get-terminal-taxes';

/**
 * Handles the form for the terminal tax page
 */
export const formTerminalTax = async () => {
  if ( !TERMINAL_DEFAULT_TAX.addDTTLink ) return;

  // const linkAction = getParameters('linkAction');
  // const partnerID = getParameters('partnerID');
  const terminalID = getParameters('terminalID');

  const [ terminal, tax ] = await Promise.all([
    displayIndividualTerminal(terminalID),
    getTerminalTaxes(terminalID)
  ]);

  parseTerminalInfo(terminal.body);

  const { assigned, avlTax } = tax.body;

  const assignedTaxIds = new Set(assigned.map(item => item.taxId));
  const availTax = avlTax.filter(item => !assignedTaxIds.has(item.taxId));

  displayDefaultTaxes(assigned, TERMINAL_DEFAULT_TAX.searchSelected);

  const { accessType } = useAuth()!;
  if ( accessType === 'E' ) {
    taxListWidget(availTax, TERMINAL_DEFAULT_TAX.searchResults);
    searchAvailableItems(TERMINAL_DEFAULT_TAX.searchInput, TERMINAL_DEFAULT_TAX.searchResults);
    getSelectedTax(TERMINAL_DEFAULT_TAX.searchResults, TERMINAL_DEFAULT_TAX.searchSelected, terminalID);
  } 

  FORM_LOADER.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style');
}

/**
 * Parses the terminal info from the AWS api call
 * 
 * @param {object} data the terminal data object
 * 
 * @returns void
 */
const parseTerminalInfo = (data: ITerminal[]) => {  
  const { partnerName, terminalName, terminalId } = data[0];

  TERMINAL_DEFAULT_TAX.partnerName.value = partnerName;
  TERMINAL_DEFAULT_TAX.terminalName.value = terminalName ? terminalName : terminalId!;
}

/**
 * Gets the selected tax from the available tax list
 * 
 * @param {HTMLElement} avalContainer the available tax container
 * @param {HTMLElement} resultsContainer the selected tax container
 * @param {string} terminalID the terminal id
 * 
 * @returns void
 */
const getSelectedTax = (avalContainer: HTMLElement, resultsContainer: HTMLElement, terminalID: string) => {
  avalContainer?.addEventListener('click', e => {
    const target = e.target as HTMLElement;
    const { id, name, rate } = target.dataset;

    if (id && name && rate) {
      const data = [{ taxId: id, taxName: name, taxRate: rate }];
      displayDefaultTaxes(data, resultsContainer);
      target.parentElement?.remove();
      addTerminalTax(terminalID);
    }

    searchClear(TERMINAL_DEFAULT_TAX.searchInput, TERMINAL_DEFAULT_TAX.searchResults);
  });
}
